import { IFormValidations } from '@aston/foundation';

import { NewAccountCompanyValidator } from './new-account.validators';
import { ContactFormValidator } from './contact-form.validators';
import { UpdateSubsidiaryValidator } from './update-subsidiary.validators';
import { NewSubsidiaryUserValidator } from './new-subsidiary-user.validators';
import { CreateRegistrationUserSubsidiaryValidator } from './create-subsidiary-user-form.validators';
import { CreateDelegationCommandValidator } from './user-delelegation-form.validators';
import { CreateFederationValidator } from './create-federation.validators';
import { CreateRegistrationUserFederationValidator } from './create-federation-user-form.validators';
import { NewFederationUserValidator } from './new-federation-user.validators';
import { UpdateFederationValidator } from './update-federation.validators';
import { UpdateSubsidiaryUserInactivityCommandValidator } from './user-inactivity-form.validators';


export const ConsoleDomainValidators: IFormValidations = {
	NewAccountCompanyValidator,
	ContactFormValidator,
	UpdateSubsidiaryValidator,
	NewSubsidiaryUserValidator,
	UpdateFederationValidator,
	NewFederationUserValidator,
	CreateRegistrationUserSubsidiaryValidator,
	CreateRegistrationUserFederationValidator,
	CreateDelegationCommandValidator,
	CreateFederationValidator,
	UpdateSubsidiaryUserInactivityCommandValidator,
};
